import React from 'react';
import {
    Route,
    BrowserRouter,
    Switch,
} from 'react-router-dom';
import Home from '../containers/home';
import Contact from '../containers/contact';
import Service from '../containers/service'
import Faq from '../containers/faq'
import PageNotFound from '../containers/pageNotFound';
import PrivacyPolicy from "../containers/privacyPolicy";
import GuideAutoTransfer from "../containers/guide-auto-transfer";
import GuideAutoTransferApp from "../containers/guide-auto-transfer-app";

const Main = () => (
    <BrowserRouter>
        <Switch>
            <Route exact path="/" component={Home} />
            <Route path="/contact" component={Contact} />
            <Route path="/service" component={Service} />
            <Route path="/faq" component={Faq} />
            <Route path="/a/faq" component={Faq} />
            <Route path="/privacy" component={PrivacyPolicy} />
            <Route path="/guide/auto-transfer" component={GuideAutoTransfer} />
            <Route path="/guide/auto-transfer-app" component={GuideAutoTransferApp} />
            <Route component={PageNotFound} />
        </Switch>
    </BrowserRouter>
);

export default Main;



// WEBPACK FOOTER //
// ./src/routes/Main.js